import { get, values } from 'lodash-es'

export const getFeedDescription = ({ feeds, feedId }) => {
  if (feedId) {
    return get(feeds[feedId.split('----')[0]], 'description')
  }
  return get(
    values(feeds)
      .filter(i => i.home)
      .sort((a, b) => a.position - b.position)[0],
    'description'
  )
}
